import designTokens from 'theme/design-tokens';

export const cloverColors = designTokens.cloverColors;

export const cloverThemeVars = {
  '--primary100': cloverColors.purple100,
  '--primary300': cloverColors.purple300,
  '--primary400': cloverColors.purple400,
  '--primary500': cloverColors.purple500,
  '--primary700': cloverColors.purple700,
  '--primary900': cloverColors.purple900,
  '--mono0': cloverColors.mono0,
  '--mono100': cloverColors.mono100,
  '--mono300': cloverColors.mono300,
  '--mono400': cloverColors.mono400,
  '--mono500': cloverColors.mono500,
  '--mono700': cloverColors.mono700,
  '--mono900': cloverColors.mono900,
};
